import axios from '@shared/axios-shared';

const BASE = '/api/v2/billing/invoices';

export const listBillingInvoices = (params = {}) => axios.get(BASE, { params });
export const getBillingInvoice = (id) => axios.get(`${BASE}/${id}`);

// Bulk per-student rollup powering Outstanding / Last Paid / Next Invoice on
// the Students table and the student-detail header cards.
export const getBillingInvoiceStudentSummary = (studentIds = []) =>
	axios.get(`${BASE}/student-summary`, { params: { student_ids: studentIds } });

// School-wide aggregate for the Billing Summary page MetricCards.
export const getBillingInvoiceSchoolSummary = () => axios.get(`${BASE}/school-summary`);

// Admin-initiated invoice actions. Both write to billing_event_logs with the
// supplied reason, so the History tab can label why the action happened.
export const voidBillingInvoice = (id, body) => axios.post(`${BASE}/${id}/void`, body);
export const refundBillingInvoice = (id, body) => axios.post(`${BASE}/${id}/refund`, body);

/**
 * Manually re-send an open/past_due invoice email via Stripe. 5-minute
 * cooldown enforced on the BE so rapid clicks don't spam the family.
 * Returns 422 with code=reminder_cooldown if the cooldown is hit.
 */
export const sendBillingInvoiceReminder = (id) =>
	axios.post(`${BASE}/${id}/send-reminder`);

/**
 * Queue reminders for a SELECTION of invoices — the Unpaid Balances tab's
 * multi-select action.
 *
 * `invoiceIds` is a set of `billing_invoices.id` values and never a filter
 * description: a filter re-evaluated on the worker can select rows the
 * administrator never saw on the page they were looking at.
 *
 * Answers 202 `{ batch_id, queued, rejected }`. Duplicates are collapsed
 * server-side and the ids that did not survive re-scoping to the resolved
 * school are reported in `rejected` rather than dropped, so `queued` plus
 * `rejected.length` accounts for the whole submitted selection. No vendor call
 * happens in the request; the work runs on the billing queue.
 */
export const sendBulkInvoiceReminders = (invoiceIds) =>
	axios.post(`${BASE}/reminders/bulk`, { invoice_ids: invoiceIds });

/**
 * Poll one bulk send by the identifier its dispatch returned.
 *
 * Carries the batch's own progress beside the per-outcome counts, every member
 * of the closed outcome set present even at zero — so a caller never has to
 * decide whether an absent key means none or means unknown. Answers 404 for a
 * batch that belongs to another school.
 */
export const getBulkInvoiceReminderStatus = (batchId) => axios.get(`${BASE}/reminders/bulk/${batchId}`);
